import PropTypes from "prop-types";

export const SeatsBookPaymentType = PropTypes.shape({
    payment_id: PropTypes.any,
    amount: PropTypes.number,
    payment_method: PropTypes.string,
    description: PropTypes.string,
    payment_reference: PropTypes.string
});
